import React from 'react';

import {getLocalizedStrings} from '../../../services/localization/localizationService';
import AppButton from '../../Button/AppButton/AppButton';
import ContentWrapper from '../../Layout/ContentWrapper';
import MaxWidthContainer from '../../Layout/MaxWidthContainer';
import Article from '../Article';
import InstructionStepsList from './components/InstructionStepsList';

const InstructionModalTemplate = (props) => {
    const {
        subTitleText,
        subTitleKey,
        children,
        className,
        instructionList,
        articleProps,
        buttonProps,
        instructionButtonProps,
        skipButtonProps,
    } = props;
    const localizedStrings = getLocalizedStrings();
    const subTitle = subTitleText || localizedStrings[subTitleKey];

    return (
        <MaxWidthContainer size='m' className={className}>
            <ContentWrapper className='md:mx-8 lg:mx-0'>
                <Article {...articleProps} />
            </ContentWrapper>
            {instructionList && (
                <InstructionStepsList
                    subTitle={subTitle}
                    instructionKey={instructionList}
                    instructionButton={instructionButtonProps}
                    skipButton={skipButtonProps}
                />
            )}
            {buttonProps && (
                <div className='w-full md:w-auto'>
                    <ContentWrapper>
                        <AppButton {...buttonProps} />
                    </ContentWrapper>
                </div>
            )}
            {children}
        </MaxWidthContainer>
    );
};

export default InstructionModalTemplate;
